var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { logger } from './logger';
import { connect, LocalAudioTrack, LocalVideoTrack, LocalDataTrack, } from 'twilio-video';
import { MediaProvider, TrackType, } from '@withso/pop-media-sdk';
var INTERNAL_DATA_TRACK_NAME = 'popmedia-internal-data-track';
var TwilioProvider = /** @class */ (function (_super) {
    __extends(TwilioProvider, _super);
    function TwilioProvider(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this) || this;
        _this.options = options;
        _this._room = null;
        _this._internalDataTrack = null;
        _this.connectToRoom = function (mediaToken, localTracks) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, participant;
            var e_1, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, connect(mediaToken, __assign(__assign({}, this.options), { tracks: this.prepareInitialLocalTracks(localTracks), video: false, audio: false }))];
                    case 1:
                        _a._room = _e.sent();
                        logger.debug('[Twilio] connected, local participant SID', this._room.localParticipant.sid);
                        this._room.on('disconnected', this.handleDisconnect);
                        this._room.on('reconnecting', this.handleReconnecting);
                        this._room.on('reconnected', this.handleReconnect);
                        this._room.on('participantConnected', this.handleParticipantConnected);
                        this._room.on('participantDisconnected', this.handleParticipantDisconnected);
                        // typing on these handlers is a bit more loose than the events
                        // but still valid (basically only accessing sids)
                        this._room.on('trackSubscribed', this.handleTrackSubscribed);
                        this._room.on('trackUnsubscribed', this.handleTrackUnsubscribed);
                        // immediately trigger connection events for all existing participants
                        this.handleParticipantConnected(this._room.localParticipant);
                        try {
                            for (_b = __values(this._room.participants.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                                participant = _c.value;
                                this.handleParticipantConnected(participant);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_d = _b.return)) _d.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        // connect the internal data track
                        this._internalDataTrack = new LocalDataTrack({
                            name: INTERNAL_DATA_TRACK_NAME,
                            logLevel: 'warn',
                        });
                        this._room.localParticipant.publishTrack(this._internalDataTrack);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.prepareInitialLocalTracks = function (localTracks) {
            return Object.entries(localTracks)
                .filter(function (_a) {
                var _b = __read(_a, 2), _ = _b[0], track = _b[1];
                return !!track;
            })
                .map(function (_a) {
                var _b = __read(_a, 2), trackType = _b[0], track = _b[1];
                return _this.wrapTrack(track, trackType);
            });
        };
        _this.handleDisconnect = function () {
            logger.debug('[Twilio] disconnected');
            _this.onDisconnect();
        };
        _this.handleReconnecting = function () {
            logger.debug('[Twilio] reconnecting');
            _this.onReconnecting();
        };
        _this.handleReconnect = function () {
            logger.debug('[Twilio] reconnected');
            _this.onReconnect();
        };
        _this.getParticipantId = function (participant) {
            // it's just the identity (this is set on the server when generating the token)
            return participant.identity;
        };
        _this.handleParticipantConnected = function (participant) {
            var e_2, _a;
            logger.debug('[Twilio] participant connected', participant.sid);
            var participantId = _this.getParticipantId(participant);
            _this.onParticipantConnected(participant.sid, participantId);
            try {
                // immediately trigger start events for all participant tracks
                for (var _b = __values(participant.tracks.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var track = _c.value;
                    if ((isMediaTrackPublication(track) || isDataTrackPublication(track)) &&
                        track.track) {
                        _this.handleTrackSubscribed(track.track, track, participant);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
        _this.handleParticipantDisconnected = function (participant) {
            logger.debug('[Twilio] participant disconnected', participant.sid);
            _this.onParticipantDisconnected(participant.sid);
        };
        _this.getTrackType = function (track) {
            return track.name;
        };
        _this.handleTrackSubscribed = function (track, pub, participant) {
            logger.debug("[Twilio] track subscribed: ".concat(pub.trackSid, " by ").concat(participant.sid));
            if (isMediaTrackPublication(pub)) {
                var trackType = _this.getTrackType(track);
                _this.onTrackSubscribed(participant.sid, trackType);
            }
            else if (isDataTrackPublication(pub)) {
                _this.handleDataTrackSubscribed(track, pub, participant);
            }
        };
        _this.handleDataTrackSubscribed = function (track, pub, participant) {
            if (track.name === INTERNAL_DATA_TRACK_NAME) {
                track.on('message', function (data) {
                    return _this.handleInternalDataTrackMessage(data, participant);
                });
            }
            // TODO: other data tracks
        };
        _this._textDecoder = new TextDecoder('utf-8');
        _this.handleInternalDataTrackMessage = function (data, fromParticipant) {
            if (typeof data === 'string') {
                _this.onMessage(fromParticipant.sid, data);
            }
            else {
                _this.onMessage(fromParticipant.sid, _this._textDecoder.decode(data));
            }
        };
        _this.handleTrackUnsubscribed = function (track, pub, participant) {
            logger.debug("[Twilio] track unsubscribed: ".concat(pub.trackSid, " by ").concat(participant.sid));
            var trackType = _this.getTrackType(track);
            if (!trackType) {
                logger.warn('[Twilio] track unsubscribed but track type not recognized', pub.trackSid, participant.sid);
                return;
            }
            // cleanup internal data track listener
            if (isDataTrackPublication(pub) &&
                pub.track &&
                pub.trackName === INTERNAL_DATA_TRACK_NAME) {
                pub.track.off('message', _this.handleInternalDataTrackMessage);
            }
            _this.onTrackUnsubscribed(participant.sid, trackType);
        };
        _this.disconnectFromRoom = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this._room) {
                    this._room.disconnect();
                    // act as if our own participant disconnected - Twilio will not fire these
                    // events like it would for remote participants
                    this.handleParticipantDisconnected(this._room.localParticipant);
                    this._room = null;
                }
                return [2 /*return*/];
            });
        }); };
        _this.getMediaStreamTrack = function (participantSid, trackSid) {
            if (!_this._room) {
                return null;
            }
            var participant;
            if (participantSid === _this._room.localParticipant.sid) {
                participant = _this._room.localParticipant;
            }
            else {
                participant = _this._room.participants.get(participantSid);
            }
            if (!participant) {
                logger.warn("[Twilio] Participant SID ".concat(participantSid, " not found"));
                return null;
            }
            var pub = participant.tracks.get(trackSid);
            if (!pub) {
                logger.warn("[Twilio] Track SID not found: ".concat(trackSid));
                return null;
            }
            if (!isMediaTrackPublication(pub)) {
                return null;
            }
            var track = pub.track;
            if (!track)
                return null;
            return track.mediaStreamTrack;
        };
        _this.getLocalParticipantSid = function () {
            if (!_this._room) {
                return null;
            }
            return _this._room.localParticipant.sid;
        };
        _this.wrapTrack = function (track, trackType) {
            if (trackType === TrackType.Microphone ||
                trackType === TrackType.ScreenAudio) {
                return new LocalAudioTrack(track, {
                    name: trackType,
                    logLevel: 'info',
                });
            }
            else {
                return new LocalVideoTrack(track, {
                    name: trackType,
                    logLevel: 'info',
                });
            }
        };
        _this.publishLocalMedia = function (trackType, mediaTrack) { return __awaiter(_this, void 0, void 0, function () {
            var track, pub;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._room) {
                            throw new Error('Cannot start media without a room');
                        }
                        track = this.wrapTrack(mediaTrack, trackType);
                        return [4 /*yield*/, this._room.localParticipant.publishTrack(track)];
                    case 1:
                        pub = _a.sent();
                        logger.debug('[Twilio] published track', pub.trackSid);
                        return [2 /*return*/, pub.trackSid];
                }
            });
        }); };
        _this.unpublishLocalMedia = function (trackSid) { return __awaiter(_this, void 0, void 0, function () {
            var pub;
            return __generator(this, function (_a) {
                if (!this._room)
                    return [2 /*return*/];
                pub = this._room.localParticipant.tracks.get(trackSid);
                if (!(pub === null || pub === void 0 ? void 0 : pub.track))
                    return [2 /*return*/];
                logger.debug('[Twilio] unpublished track', pub.trackSid);
                this._room.localParticipant.unpublishTrack(pub.track);
                return [2 /*return*/];
            });
        }); };
        _this.getParticipantBySid = function (sid) {
            if (!_this._room)
                return null;
            if (sid === _this._room.localParticipant.sid) {
                return _this._room.localParticipant;
            }
            return _this._room.participants.get(sid);
        };
        _this.getParticipantIdFromSid = function (sid) {
            var participant = _this.getParticipantBySid(sid);
            if (!participant)
                return null;
            return _this.getParticipantId(participant);
        };
        _this.getTrackTypeFromTrackSid = function (participantSid, trackSid) {
            var participant = _this.getParticipantBySid(participantSid);
            if (!participant)
                return null;
            var pub = participant.tracks.get(trackSid);
            if (!(pub === null || pub === void 0 ? void 0 : pub.track))
                return null;
            return _this.getTrackType(pub.track);
        };
        _this.getParticipantTrackSids = function (participantSid) {
            if (!_this._room)
                return [];
            var participant = _this.getParticipantBySid(participantSid);
            if (!participant)
                return [];
            return Array.from(participant.tracks.keys());
        };
        return _this;
    }
    TwilioProvider.prototype.sendMessage = function (message) {
        if (!this._internalDataTrack) {
            logger.warn('[Twilio] no internal data track ready to send data message');
            return;
        }
        this._internalDataTrack.send(message);
    };
    return TwilioProvider;
}(MediaProvider));
export { TwilioProvider };
function isMediaTrackPublication(pub) {
    return !!pub.track;
}
function isDataTrackPublication(pub) {
    return pub.kind === 'data';
}
//# sourceMappingURL=TwilioProvider.js.map